// Subcategory APIs return the parent either populated or as a raw id, under different keys.
export const getSubCategoryParentId = (subCategory) =>
  subCategory?.category?._id ||
  subCategory?.category ||
  subCategory?.categoryId?._id ||
  subCategory?.categoryId ||
  subCategory?.parentCategory?._id ||
  subCategory?.parentCategory ||
  "";
